/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkUpdateSafetyStockDto } from '../models/BulkUpdateSafetyStockDto';
import type { BulkUpdateSelectedSafetyStockDto } from '../models/BulkUpdateSelectedSafetyStockDto';
import type { UpdateSafetyStockDto } from '../models/UpdateSafetyStockDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductLocationSafetyStockService {
    /**
     * Get paginated safety stock list with filters
     * @param page Page number
     * @param limit Items per page
     * @param search Search by product name or code (partial match)
     * @param locationId Filter by branch or warehouse location ID
     * @param productType Filter by product type (category name partial match)
     * @param estado Filter by status (NORMAL, BAJO_STOCK, SIN_STOCK, NULO)
     * @param sortBy Sort field
     * @param sortOrder Sort direction
     * @returns any Paginated safety stock list
     * @throws ApiError
     */
    public static productLocationSafetyStockControllerFindAll(
        page: number = 1,
        limit: number = 10,
        search?: string,
        locationId?: number,
        productType?: string,
        estado?: 'NORMAL' | 'BAJO_STOCK' | 'SIN_STOCK' | 'NULO',
        sortBy?: 'productCode' | 'productName' | 'tipoProducto' | 'sucursalName' | 'stockDisponible' | 'stockSeguridad' | 'estado',
        sortOrder?: 'asc' | 'desc',
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/product-location-safety-stock',
            query: {
                'page': page,
                'limit': limit,
                'search': search,
                'locationId': locationId,
                'productType': productType,
                'estado': estado,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
            },
        });
    }
    /**
     * Location IDs already listed for a product (inventory or safety-stock config)
     * @param productId
     * @returns any Assigned location IDs
     * @throws ApiError
     */
    public static productLocationSafetyStockControllerGetAssignedLocationIds(
        productId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/product-location-safety-stock/products/{productId}/assigned-location-ids',
            path: {
                'productId': productId,
            },
            errors: {
                404: `Product not found`,
            },
        });
    }
    /**
     * Bulk update safety stock for explicitly selected product-location pairs
     * @param requestBody
     * @returns any Number of records updated
     * @throws ApiError
     */
    public static productLocationSafetyStockControllerBulkUpdateSelected(
        requestBody: BulkUpdateSelectedSafetyStockDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/product-location-safety-stock/bulk/selection',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Bulk update safety stock
     * @param requestBody
     * @returns any Number of records updated
     * @throws ApiError
     */
    public static productLocationSafetyStockControllerBulkUpdate(
        requestBody: BulkUpdateSafetyStockDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/product-location-safety-stock/bulk',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Upsert safety stock for product and location
     * @param productId
     * @param locationId
     * @param requestBody
     * @returns any Created or updated record
     * @throws ApiError
     */
    public static productLocationSafetyStockControllerUpsert(
        productId: number,
        locationId: number,
        requestBody: UpdateSafetyStockDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/product-location-safety-stock/upsert/{productId}/{locationId}',
            path: {
                'productId': productId,
                'locationId': locationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update safety stock by ID
     * @param id
     * @param requestBody
     * @returns any Updated record
     * @throws ApiError
     */
    public static productLocationSafetyStockControllerUpdate(
        id: number,
        requestBody: UpdateSafetyStockDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/product-location-safety-stock/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
